var $button = $('.js-show-dlbox');
var $modalDownload = $('.modal--dlbox');
var $modal = $('.modal');

function showModal_dlBox() {
	$button.on('click', function() {
		$modalDownload.addClass('modal--show');
		$body.addClass('hide-overflow');
	});

	$document.on('click.js-show-modal', function(event) {
		if ($modalDownload.hasClass('modal--show')) {
			if (!$(event.target).closest('.modal__content,.js-show-dlbox').length) {
				$modalDownload.removeClass('modal--show');
				setTimeout(function() {
					$body.removeClass('hide-overflow');
				}, 200);
			}
		}
	});
}

function closeModal() {
	$modal.find('.modal__close').on('click', function() {
		if ($modal.hasClass('modal--show')) {
			$modal.removeClass('modal--show');
			setTimeout(function() {
				$body.removeClass('hide-overflow');
			}, 200);
		}
	});
}

$(function() {
	showModal_dlBox();
	closeModal();
});